export const getSearchClassForBody = () => 'search';